<div class="chip-input-wrapper">
  <mat-form-field>
    <mat-label>Base Stations</mat-label>
    <mat-chip-grid #chipList [formControl]="deviceChipsControl" [required]="required">
      @for (value of displayValues; track value; let i = $index) {
        <mat-chip-row
          [selectable]="false"
          [removable]="true"
          (removed)="removeValue(value)"
          >{{ getChipDisplay(value) }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
      }
      <input
        cdkFocusInitial
        autocomplete="off"
        #deviceInput
        type="text"
        [formControl]="deviceInputControl"
        [lcsSingleSelect]="deviceSelect"
        [singleItemAutoSelect]="false"
        name="device-filter"
        [matChipInputFor]="chipList"
        placeholder="Search"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="add($event)"
        [openPanelOnFocus]="true"
        (blur)="removeErrors()"
        ndtDeviceSelect
        [accountId]="accountId"
        [deviceTypesToInclude]="[DeviceTypes.RoveB2, DeviceTypes.RoveB4]"
        />
      </mat-chip-grid>
      @if (deviceChipsControl.hasError('required')) {
        <mat-error> Please select one or more devices </mat-error>
      }
      <ndt-device-select
        #deviceSelect
        (optionSelected)="selected($event)"
        [devicesToExclude]="displayDevices"
      ></ndt-device-select>
    </mat-form-field>
  </div>
